// Locale strings of report 2.4 (equity-changes), accountant's document 2026-10-03.
// Merged ONCE into finance.reports2.<camelCaseSlug> by ./index.js: use
// $t("finance.reports2.<camelCaseSlug>.<key>"). Owned by this report only.
export default {
  pageTitle: "قائمة التغيرات في حقوق الملكية",
  title: "قائمة التغيرات في حقوق الملكية",
  statement: "البيان",
  total: "الإجمالي",
  unposted: "غير مرحّل",
  unpostedHint: "نتيجة قائمة الدخل غير المرحّلة إلى حقوق الملكية (محسوبة آلياً)",
  unpostedSummary: "نتيجة غير مرحّلة",
  check: "التحقق: الختامي − (الافتتاحي + الحركات)",
  difference: "الفرق",
  entriesCount: "عدد القيود",
  entry: "القيد",
  memo: "البيان",
  showEntries: "عرض القيود",
  hideEntries: "إخفاء القيود",
  outsideTitle: "حسابات حقوق ملكية خارج أعمدة القائمة",
  opening: "الرصيد الافتتاحي",
  movement: "الحركة",
  closing: "الرصيد الختامي",
  warnings: "تنبيهات",
  notes: "ملاحظات",
  sheetName: "حقوق الملكية",
  outsideSheet: "خارج الأعمدة",
  sectionTitle: "العملة",
  columns: {
    capital: "رأس المال",
    legal_reserve: "احتياطي قانوني",
    optional_reserve: "احتياطي اختياري",
    other_reserves: "احتياطيات أخرى",
    expansion_reserve: "احتياطي توسع",
    current_year_profit: "ربح العام",
    retained_earnings: "أرباح محتجزة",
  },
  rows: {
    opening: "الرصيد بداية الفترة",
    net_profit: "صافي الربح للعام",
    profit_transfer: "ترحيل ربح العام",
    legal_reserve_formation: "تكوين احتياطي قانوني",
    optional_reserve_formation: "تكوين احتياطي اختياري",
    emergency_reserve_formation: "تكوين احتياطي طوارئ",
    expansion_reserve_formation: "تكوين احتياطي توسع",
    dividends_declared: "إعلان توزيع أرباح",
    prior_year_revenues: "إيرادات سنوات سابقة",
    prior_year_expenses: "مصاريف سنوات سابقة",
    prior_profit_transfer: "ترحيل أرباح سابقة للمقارنة",
    capital_change: "زيادة / تخفيض رأس المال",
    other_movements: "حركات أخرى",
    closing: "الرصيد نهاية الفترة",
  },
};
